<div class="layoutBlock">
    <div class="columnFull">
        <p-panel
            header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts' | hisUi}}"
            [toggleable]="false">
            <div class="layoutBlock">
                <div class="columnFull">

                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.accommodationExpenses' | hisUi}}">
                        <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                            [(ngModel)]="estimatedCosts.accommodationExpenses"
                            (ngModelChange)="onModelChange($event)"></p-inputNumber>
                    </his-plam>

                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.conferenceFee' | hisUi}}">
                        <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                            [(ngModel)]="estimatedCosts.conferenceFee"
                            (ngModelChange)="onModelChange($event)"></p-inputNumber>
                    </his-plam>

                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.transportationCosts' | hisUi}}">
                        <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                            [(ngModel)]="estimatedCosts.transportationCosts"
                            (ngModelChange)="onModelChange($event)"></p-inputNumber>
                    </his-plam>

                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.otherCosts' | hisUi}}"
                        styleClass="inputWidth25">
                        <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                            [(ngModel)]="estimatedCosts.otherEstimatedCosts"
                            (ngModelChange)="onModelChange($event)"></p-inputNumber>
                    </his-plam>

                    <h3>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.totalCosts'
                        | hisUi}}
                    </h3>
                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.sumOfEstimatedCosts' | hisUi}}"
                        helptext="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.sumHelptext'}}">
                        <span #content class="plamContentText">{{sumOfEstimatedCostsFormatted}}</span>
                    </his-plam>

                    <h3>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.progressPayment'
                        |
                        hisUi}}</h3>
                    <his-plam
                        label="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.estimatedCosts.reductionOfEstimatedCosts' | hisUi}}">
                        <p-inputNumber #content mode="currency" currency="EUR" locale="de-DE"
                            [(ngModel)]="estimatedCosts.reductionOfEstimatedCosts"></p-inputNumber>
                    </his-plam>

                </div>
            </div>
        </p-panel>
    </div>
</div>